import { type RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import HomePage from "@/pages/home/page";
import ClubPage from "@/pages/club/page";
import SportPage from "@/pages/sport/page";
import CommunityPage from "@/pages/community/page";
import CulturePage from "@/pages/culture/page";
import ShopPage from "@/pages/shop/page";
import MemberPage from "@/pages/member/page";
import ForgotPasswordPage from "@/pages/forgot-password/page";
import NewsPage from "@/pages/news/page";
import NewsDetailPage from "@/pages/news/details";
import FormsPage from "@/pages/forms/page";
import AdminPage from "@/pages/admin/page";
import SocialPage from "@/pages/social/page";
import LivePage from "@/pages/live/page";
import LegalDocumentPage from "@/pages/legal/LegalDocumentPage";
import AccountDeletionPage from "@/pages/legal/AccountDeletionPage";
import MemberPasswordChangeGate from "./MemberPasswordChangeGate";

const routes: RouteObject[] = [
  {
    path: "/",
    element: (
      <MemberPasswordChangeGate>
        <HomePage />
      </MemberPasswordChangeGate>
    ),
  },
  {
    path: "/club",
    element: (
      <MemberPasswordChangeGate>
        <ClubPage />
      </MemberPasswordChangeGate>
    ),
  },
  {
    path: "/sport",
    element: (
      <MemberPasswordChangeGate>
        <SportPage />
      </MemberPasswordChangeGate>
    ),
  },
  {
    path: "/sport/calendrier",
    element: (
      <MemberPasswordChangeGate>
        <SportPage />
      </MemberPasswordChangeGate>
    ),
  },
  {
    path: "/sport/resultats",
    element: (
      <MemberPasswordChangeGate>
        <SportPage />
      </MemberPasswordChangeGate>
    ),
  },
  {
    path: "/sport/evenements",
    element: (
      <MemberPasswordChangeGate>
        <SportPage />
      </MemberPasswordChangeGate>
    ),
  },
  {
    path: "/communaute",
    element: (
      <MemberPasswordChangeGate>
        <CommunityPage />
      </MemberPasswordChangeGate>
    ),
  },
  {
    path: "/communaute/squads",
    element: (
      <MemberPasswordChangeGate>
        <CommunityPage />
      </MemberPasswordChangeGate>
    ),
  },
  {
    path: "/communaute/forum",
    element: (
      <MemberPasswordChangeGate>
        <CommunityPage />
      </MemberPasswordChangeGate>
    ),
  },
  {
    path: "/culture",
    element: (
      <MemberPasswordChangeGate>
        <CulturePage />
      </MemberPasswordChangeGate>
    ),
  },
  {
    path: "/boutique",
    element: (
      <MemberPasswordChangeGate>
        <ShopPage />
      </MemberPasswordChangeGate>
    ),
  },
  {
    path: "/membre",
    element: (
      <MemberPasswordChangeGate>
        <MemberPage />
      </MemberPasswordChangeGate>
    ),
  },
  {
    path: "/actualites",
    element: (
      <MemberPasswordChangeGate>
        <NewsPage />
      </MemberPasswordChangeGate>
    ),
  },
  {
    path: "/actualites/:id",
    element: (
      <MemberPasswordChangeGate>
        <NewsDetailPage />
      </MemberPasswordChangeGate>
    ),
  },
  {
    path: "/formulaires",
    element: (
      <MemberPasswordChangeGate>
        <FormsPage />
      </MemberPasswordChangeGate>
    ),
  },
  {
    path: "/mot-de-passe-oublie",
    element: <ForgotPasswordPage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "/social",
    element: (
      <MemberPasswordChangeGate>
        <SocialPage />
      </MemberPasswordChangeGate>
    ),
  },
  {
    path: "/live",
    element: (
      <MemberPasswordChangeGate>
        <LivePage />
      </MemberPasswordChangeGate>
    ),
  },
  {
    path: "/confidentialite",
    element: <LegalDocumentPage document="privacy" />,
  },
  {
    path: "/conditions-utilisation",
    element: <LegalDocumentPage document="terms" />,
  },
  {
    path: "/suppression-compte",
    element: <AccountDeletionPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
